import { Link, Modal, Stack } from '@amboss/design-system';
import { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { identify, trackEvent } from '../analytics';
import { AccountSetup } from '../components/cards/accountSetup/AccountSetup';
import { HomeSections } from '../components/cards/homeSections/HomeSections';
import SocketErrorCard from '../components/cards/SocketErrorCard';
import Navbar from '../components/navbar/Navbar';
import { config } from '../config';
import { SocketContext } from '../contexts/SocketProvider';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import useEditProfile from '../hooks/useEditProfile';
import useProfile from '../hooks/useProfile';
import { useSocketEmit } from '../hooks/useSocketEmit';
import {
  setTotalCredits,
  totalCreditsSelector,
} from '../store/totalCredits/totalCreditsSlice';
import { isWebview } from '../utils';

const Home = () => {
  const { profile } = useProfile();
  const { socketReady } = useContext(SocketContext);
  const [xid, setXid] = useState<string | null>(null);
  const { socketError } = useContext(SocketContext);
  const { getTotals } = useSocketEmit();
  const dispatch = useAppDispatch();
  const totalCredits = useAppSelector(totalCreditsSelector);
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const { openProfile, closeProfile } = useEditProfile();

  const getTotalCredits = useCallback(() => {
    getTotals()
      .then((response) => {
        dispatch(setTotalCredits(response));
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  useEffect(() => {
    if (socketReady) {
      getTotalCredits();
    }
  }, [socketReady, getTotalCredits]);

  useEffect(() => {
    if (!xid && profile && profile.xid) {
      setXid(profile.xid);
      identify({ xid: profile.xid, traits: {} });
      trackEvent({
        event: config.analytics.events.CME_PAGE_OPENED,
        options: { xid: profile.xid },
      });
    }
  }, [profile, xid]);

  useEffect(() => {
    if (!isOpen && !profile?.clinicalRole) {
      openProfile();
    }
    if (isOpen) {
      closeProfile();
    }
  }, [isOpen, profile?.clinicalRole]);

  return (
    <div style={{ padding: '32px 0px' }}>
      {!isWebview() && <Navbar />}
      {socketReady && (
        <div className='home-container' style={{ paddingTop: !isWebview() ? 56 : 0 }}>
          <Stack space={'m'}>
            <AccountSetup />
            {totalCredits && <HomeSections totals={totalCredits} />}
          </Stack>
        </div>
      )}
      {isOpen && !socketError && (
        <div style={{ zIndex: 9999 }}>
          <Modal
            actionButton={{ text: t('home.modal.button') }}
            isDismissible={true}
            header={''}
            onAction={() => {
              setIsOpen(false);
            }}
            role='dialog'
          >
            <Modal.Text>
              {' '}
              {t('home.modal.text')}{' '}
              <Link
                color='accent'
                size='m'
                target='_blank'
                rel='noopener noreferrer'
                href='https://support.amboss.com/hc/en-us/articles/4405038645140-Contacting-AMBOSS-Support'
              >
                here
              </Link>
              .
            </Modal.Text>
          </Modal>
        </div>
      )}
      {socketError && <SocketErrorCard />}
    </div>
  );
};

export default Home;
